import { AppBasicPartner } from '../../models/interfaces/app-basic-partner.interface'
import { AppBasicPerson } from '../../models/interfaces/app-basic-person.interface'
import { AppBasicDocumentRes } from '../../models/interfaces/app-basic-document.interface'
import { AppReportingPeriodResponse } from '../../models/interfaces/app-reporting-period.interface'
import { TodoTableData, Todo } from '../../../features/feature-partners/models/interfaces/table-todo-data.interface'
import { AppProgressbarState } from '../../models/interfaces/app-progressbar-state.interface'

export interface ProjectState {
   exportProgress?: AppProgressbarState
   partnerList?: AppBasicPartner[]
   isLoadingPartnerList?: boolean
   projectTodoData?: TodoTableData
   isLoadingProjectTodo?: boolean
   partnerActive?: AppBasicPartner
   isLoadingPartnerActive?: boolean
   personActive?: AppBasicPerson
   isLoadingPersonActive?: boolean
   personEmailSearchResults?: AppBasicPerson[]
   isLoadingPersonEmailSearch?: boolean
   todoActive?: Todo
   isLoadingTodoActive?: boolean
   reportingPeriods?: AppReportingPeriodResponse
   isLoadingReportingPeriods?: boolean
   logo?: Blob
   isLoadingLogo?: boolean
   documents?: AppBasicDocumentRes
   isLoadingDocuments?: boolean
}

export const initialProjectState: ProjectState = {}
